import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"
import Spacer from "@p-ban/common/src/components/layout/Spacer"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import estimateField from "../../../../../service/estimateFields/estimateField"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"

import img from "./externalsSilk.png"

const 外形が特殊形状_カードエッジコネクタ = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { externalsSilk: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField
      isShow={shouldShow}
      legend={`外形が特殊形状※・\nカードエッジ\nコネクタ※`}
      src={img}
      helpURL={HELP_LINKS["外形が特殊形状・カードエッジコネクタ"]}
    >
      <RadioGroup name={estimateField.externalsSilk.key} selectedValue={values.externalsSilk} onChange={handlers.radio}>
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT["外形が特殊形状・カードエッジコネクタ"].あり.value}>あり</Radio>
          <Radio value={ESTIMATE_CONSTANT["外形が特殊形状・カードエッジコネクタ"].なし.value}>なし</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.externalsSilk}>
        <OneClickFieldStack>
          <p>※外形が円形及び角丸箇所が5カ所以上・外形の角が10カ所以上</p>
          <Spacer size={8} />
          <p>※基板端に設けるカードなどを差し込むための端子形状</p>
        </OneClickFieldStack>
      </OneClickFieldMessages>
    </OneClickField>
  )
}

export default 外形が特殊形状_カードエッジコネクタ
